import { render, staticRenderFns } from "./RecruitmentListPage.vue?vue&type=template&id=97843b4c"
import script from "./RecruitmentListPage.vue?vue&type=script&lang=js"
export * from "./RecruitmentListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports